/*
 * @Description: 用这种方式的话，数据类型检查没想到好的办法传递
 * @Date: 2022-04-11 21:00:04
 */
import {
  ref,
  reactive,
  defineComponent,
  getCurrentInstance,
  nextTick
} from 'vue';
import { List } from 'vant';
import { isFunction } from '@/utils/is';

export default defineComponent({
  name: 'xrk-list',
  setup() {
    const currentInstance = getCurrentInstance();
    const loading = ref<boolean>(false);
    const finished = ref<boolean>(false);
    const attrs = currentInstance.attrs || {};
    const onLoad = attrs.getList;
    const list = reactive<Array<any>>([]);
    if (onLoad && isFunction<Function>(onLoad)) {
      // 重写onLoad函数  主要是为了混入loading状态
      attrs.onLoad = async ({ ...params }: any) => {
        if (loading.value || finished.value) {
          return;
        }
        loading.value = true;
        try {
          const resList = await onLoad(params);
          if (!resList || resList.length == 0) {
            finished.value = true;
          }
          list.push(...resList);
          nextTick(() => {
            loading.value && (loading.value = false);
            currentInstance.emit('loadFinish', list);
          });
        } catch (error) {
          loading.value = false;
        }
      };
    } else {
      console.warn('使用xrk-list组件需要传入onLoad属性');
    }
    return { list, loading, finished, attrs, slots: currentInstance.slots };
  },
  render() {
    return (
      <List
        loading={this.loading}
        finished={this.finished}
        finished-text="已加载全部"
        {...this.attrs}
      >
        {{
          default: () => this.slots?.default?.({ list: this.list })
        }}
      </List>
    );
  }
});
